module.exports = __webpack_public_path__ + "static/media/Connect plus.aaf1c0d6.svg";